import React from 'react';
import axios from 'axios';

import Loading from '../Components/Loading';

import { useTimeModal } from './TimeModal/TimeModalContext';

import styles from '../styles/Balance.module.css';

const Balance = ({ userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();
    const [amount, setAmount] = React.useState('');
    const [isShowContent, setIsShowContent] = React.useState(false);

    const [loading, setLoading] = React.useState(false);

    const changeBalance = (action) => {
        const token = localStorage.getItem('token');
        setLoading(true);

        if (!amount) {
            openTimeModal('Заполните поле суммы', 'error');
            return setLoading(false);
        }

        axios.put(`/api/change-balance`, {
            userId,
            action,
            amount
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            openTimeModal('Операция записана', 'success');
            onSuccess();
        })
        .catch((error) => {
            console.error(error);
            openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    return (
    <>
        {isShowContent ?
            <div className={styles.panel}>
                <div className={styles.header}>
                    <h2 className={styles.headline}>Измените баланс</h2>
                    <svg onClick={() => {setIsShowContent(false)}} viewBox="0 0 24 24" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="#000000"/>
                    </svg>
                </div>
                {loading ? <Loading /> :
                <>
                    <a>Введите сумму</a>
                    <input type='number' value={amount} onChange={(e) => setAmount(e.target.value)} maxLength='7' placeholder='Сумма' required />
                    <div className={styles.containerBtns}>
                        <button type='button' className='miniButton' onClick={() => {changeBalance('+')}}>Записать в счёт</button>
                        <button type='button' className='miniButton' onClick={() => {changeBalance('-')}}>Вычесть из счёта</button>
                    </div>
                </>}
            </div>
        :
            <button type='button' className='button' onClick={() => {setIsShowContent(true)}}>Взаимодействие со счётом</button>
        }
    </>
    )
}

export default Balance;